"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharedDocumentNotificationStatuses = exports.sharedDocumentNotificationKinds = void 0;
/**
 * Why a shared-document e-mail went out: the publication itself, or a
 * reminder to those who have not read it yet.
 */
exports.sharedDocumentNotificationKinds = [
    'publication',
    'relance',
];
/**
 * Where one notification e-mail stands: queued (`pending`), taken by the
 * e-mail provider (`sent`), or refused or lost on the way (`failed`).
 */
exports.sharedDocumentNotificationStatuses = [
    'pending',
    'sent',
    'failed',
];
